import { render, staticRenderFns } from "./SolanAbout.vue?vue&type=template&id=4318f75a&scoped=true&"
import script from "./SolanAbout.vue?vue&type=script&lang=ts&"
export * from "./SolanAbout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318f75a",
  null
  
)

export default component.exports